import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UwTableComponent } from './uw-table.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuModule } from '@angular/material/menu';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from '@uw/shared/shared.module';
import { DynamicTableComponent } from './dynamic-table.component';
import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule } from '@angular/material/button';



@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        MatPaginatorModule,
        MatSortModule,
        MatTableModule,
        MatIconModule,
        MatMenuModule,
        MatButtonModule,
        SharedModule,
        UwTableComponent,
        DynamicTableComponent
    ],
    exports: [UwTableComponent, DynamicTableComponent]
})
export class UwTableModule { }
